import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { WHATSAPP_URL } from "config/constants";
import { useCallback } from "react";
import { Link as RouterLink } from "react-router-dom";
import { GetList } from "types/data-content";

interface IServicePage {
  pageData: GetList;
}

const HeroSection = ({ pageData }: IServicePage) => {
  const onContactClick = useCallback(() => {
    window.open(WHATSAPP_URL, "_blank");
  }, []);

  return (
    <section className="bg-hero-gradient text-primary-foreground py-8 sm:py-20 sm:px-6 bg-gradient-primary">
      <div className="container mx-auto sm:max-w-4xl text-center animate-fade-in">
        <h1 className="text-2xl md:text-4xl font-bold mb-6">
          {pageData.titlePage}
        </h1>
        <p
          className="text-[16px] text-white/90 mb-8"
          dangerouslySetInnerHTML={{ __html: pageData.description }}
        />

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          justifyContent="center"
        >
          <Button
            onClick={onContactClick}
            variant="contained"
            startIcon={<WhatsAppIcon />}
            sx={{
              backgroundColor: "white",
              color: "primary.main",
              fontWeight: "bold",
              px: 4,
              py: 1.5,
              borderRadius: "50px",
              transition: "0.5s",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.9)",
                transform: "scale(1.05)",
                transition: "0.5s",
              },
              "@media (max-width:599px)": {
                maxWidth: "230px",
                width: "100%",
                alignSelf: "center",
              },
              "@media (max-width:480px)": {
                fontSize: "14px",
                py: 1.3,
              },
            }}
          >
            Fale conosco
          </Button>

          <Button
            component={RouterLink}
            to="/agendar"
            variant="outlined"
            startIcon={<CalendarMonthIcon />}
            sx={{
              borderColor: "rgba(255, 255, 255, 0.7)",
              color: "white",
              fontWeight: "bold",
              px: 4,
              py: 1.5,
              borderRadius: "50px",
              transition: "0.5s",
              "&:hover": {
                borderColor: "white",
                backgroundColor: "rgba(255, 255, 255, 0.12)",
                transform: "scale(1.05)",
                transition: "0.5s",
              },
              "@media (max-width:599px)": {
                maxWidth: "230px",
                width: "100%",
                alignSelf: "center",
              },
              "@media (max-width:480px)": {
                fontSize: "14px",
                py: 1.3,
              },
            }}
          >
            Agendar reunião
          </Button>
        </Stack>
      </div>
    </section>
  );
};

export default HeroSection;
